import React from 'react'
import { useCopyNode } from '../TreeActions'
import { Box } from '@mui/material'
import { SourceTreeManagement, DoTheAction } from './SourceTreeManagement'
import { useAtom, useAtomValue } from 'infrastructure/state/jotai.wrapper'
import {
  copySourceNodeAtom,
  selectedDestinationSiblingNodeAtom,
  selectedNodeAtom,
  workingTreeAtom,
} from './atoms'

// This component presents the button that will initiate the action
// and the tree in which the user can select the node to copy the source into
export function CopyNode() {
  const [sourceNode, setSourceNode] = useAtom(copySourceNodeAtom)
  const { resetTree } = useAtomValue(workingTreeAtom)
  const destParent = useAtomValue(selectedNodeAtom)
  const siblingNode = useAtomValue(selectedDestinationSiblingNodeAtom)
  const copyNode = useCopyNode()
  const actionDisabled = !sourceNode || !destParent
  const doIt = async () => {
    if (actionDisabled) return
    await copyNode({
      sourceNode,
      siblingNode,
      destParent,
    })
    setSourceNode(undefined)
    resetTree?.()
  }

  return (
    <Box>
      <DoTheAction
        action={doIt}
        actionName={'Duplicate'}
        disabled={actionDisabled}
      />
      <SourceTreeManagement action={'Copy'} />
    </Box>
  )
}
